module.exports = __webpack_public_path__ + "fonts/icon_set_2.edc381e2.ttf";